export default __webpack_public_path__ + "static/media/expense_tracker.0db6d782.png";